import { render, staticRenderFns } from "./VentasDetails.vue?vue&type=template&id=b065f13c"
import script from "./VentasDetails.vue?vue&type=script&lang=js"
export * from "./VentasDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports